import Select from 'react-select'
import InfoBox from 'components/InfoBox'

const CustomerSwitcher = ({
  customers,
  changeCustomer,
  customer,
  dark,
  displayName,
  isStarted,
  callhandlerEnabled
}) => {
  const defaultLabel = () => {
    const value = customers.find((cust) => cust.value === customer)

    if (!value) return

    return value.label
  }

  const defaultOption = {
    value: customer,
    label: defaultLabel()
  }

  const customStyles = {
    container: () => ({
      position: 'relative',
      zIndex: 1000
    }),
    menuList: () => ({
      backgroundColor: 'lightGrey'
    }),
    option: (provided, state) => ({
      ...provided,
      borderBottom: '1px dotted pink',
      color: state.isFocused
        ? 'var(--white)'
        : state.isSelected
          ? 'var(--main-color)'
          : null,
      backgroundColor: state.isFocused ? 'var(--main-color)' : 'lightGrey',
      padding: 20
    }),
    dropdownIndicator: () => ({
      color: dark ? '#5b5b5b' : 'var(--white)',
      padding: '5px 0px 0px 3px'
    }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      width: 200,
      border: '4px solid var(--main-color)',
      display: 'flex',
      borderRadius: '1rem',
      padding: '4px 12px'
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1
      const transition = 'opacity 300ms'
      const styles = {
        color: dark ? '#5b5b5b' : 'var(--white)',
        fontWeight: 700,
        textTransform: 'capitalize'
      }

      return { ...provided, ...styles, opacity, transition }
    }
  }

  if (customers.length === 1) {
    const [{ label }] = customers
    return <InfoBox info={displayName || label} dark={dark} />
  }

  return (
    <Select
      styles={customStyles}
      isDisabled={callhandlerEnabled && isStarted === undefined}
      defaultValue={defaultOption}
      onChange={changeCustomer}
      options={customers}
      classNames={{
        option: (state) =>
          (state.isFocused || state.isSelected) && 'select-option'
      }}
    />
  )
}

export default CustomerSwitcher
